import React from 'react';
import { Footer } from '../Footer';
import StationCreator from '../StationCreator';

export default function StationList({ stations }) {
  const stationCreatorHeight = 338;
  const stationCreatorWidth = 246;
  return (
    <div className="isV2LegacyPage">
      <div
        style={{
          paddingTop: 40,
          overflow: 'hidden',
          backgroundColor: '#ffffff',
          backgroundImage:
            'url(https://d12xoj7p9moygp.cloudfront.net/images/mic-bg.png)',
          backgroundRepeat: 'repeat',
        }}
      >
        {stations.map(
          ({ stationId, creator }) =>
            creator && (
              <StationCreator
                key={stationId}
                stationId={stationId}
                creator={creator}
                width={stationCreatorWidth}
                height={stationCreatorHeight}
              />
            )
        )}
      </div>
      <Footer />
    </div>
  );
}
